// Angular Imports
import { ChangeDetectionStrategy, Component, input, Input, output } from '@angular/core'
// Shared Imports
import { EColor, EFontSize, EIcons } from '@shared/models'
import { IconComponent } from '../../icons/icon/icon.component'
import { InfoTooltipComponent } from '../../info-tooltip/info-tooltip.component'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { FormsModule } from '@angular/forms'

@Component({
	standalone: true,
	selector: 'app-tile-square',
	imports: [IconComponent, InfoTooltipComponent, MatSlideToggleModule, FormsModule],
	templateUrl: './tile-square.component.html',
	styleUrls: ['./tile-square.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileSquareComponent {
	readonly ETileType = ETileType

	@Input({ required: true }) name = ''
	@Input({ required: true }) value: string | number | null | undefined;
	@Input() color: keyof typeof EColor = EColor.greenOne
	@Input() fontSize: keyof typeof EFontSize = EFontSize.headingTwo
	@Input() fontSizeLabel: keyof typeof EFontSize = EFontSize.normal
	@Input() type: keyof typeof ETileType = ETileType.normal
	@Input() icon: EIcons = EIcons.circleUserSolid
	@Input() uppercase = false
	@Input() isIcon: boolean = true
	@Input() isButton: boolean = false
	@Input() isChecked: boolean = false
	@Input() tooltipText?: string
	isDisabled = input<boolean>(false)
	clicked = output<void>() // Nomenclatura nueva

	onClicked() {
		this.clicked.emit()
	}

}

enum ETileType {
	normal = 'normal',
	filled = 'filled',
}
